'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border : 0;\n  height : 1px;\n  background : #003DA5;\n  margin : 2em 0;\n  \n  &.lightGrey{\n\t  background:#d3d8de;\n  }\n  \n  .we_footer &&{\n\t height:0;\n\t background:transparent;\n  }\n'], ['\n  border : 0;\n  height : 1px;\n  background : #003DA5;\n  margin : 2em 0;\n  \n  &.lightGrey{\n\t  background:#d3d8de;\n  }\n  \n  .we_footer &&{\n\t height:0;\n\t background:transparent;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Hr = _styledComponents2.default.hr(_templateObject);

exports.default = Hr;